import { render } from "./CameraView2.vue?vue&type=template&id=4a162e88"
import script from "./CameraView2.vue?vue&type=script&lang=js"
export * from "./CameraView2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__